import { AUDIENCES } from '../constants/content';

export default function Audiences() {
  return (
    <section className="fm-section" id="audiences">
      <div className="fm-container">
        <div className="fm-sec-head">
          <p className="fm-kicker">Who it’s for</p>
          <h2 className="fm-sec-title">Built for people who ship</h2>
          <p className="fm-sec-lead">
            Whether you freelance solo or lead a growing team, GearsZone helps
            you get the right software without friction.
          </p>
        </div>
        <div className="fm-audience-grid">
          {AUDIENCES.map((item) => (
            <article key={item.title} className="fm-audience">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
